<template>
  <div class="min-h-screen flex items-center justify-center bg-secondary-50 dark:bg-secondary-900 px-4">
    <div class="max-w-md w-full text-center">
      <div class="text-9xl font-bold text-primary-600 dark:text-primary-400">404</div>
      <h1 class="mt-4 text-3xl font-bold text-secondary-900 dark:text-white">Page Not Found</h1>
      <p class="mt-2 text-secondary-600 dark:text-secondary-400">
        Sorry, we couldn't find the page you're looking for.
      </p>
      <div class="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          href="/"
          class="inline-flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
        >
          <HomeIcon class="h-5 w-5 mr-2" />
          Go Home
        </Link>
        <button
          @click="goBack"
          class="inline-flex items-center justify-center px-4 py-2 bg-secondary-100 dark:bg-secondary-700 text-secondary-700 dark:text-secondary-300 rounded-lg hover:bg-secondary-200 dark:hover:bg-secondary-600 transition-colors font-medium"
        >
          <ArrowLeftIcon class="h-5 w-5 mr-2" />
          Go Back
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link, router } from '@inertiajs/vue3';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/vue/24/outline';

const goBack = () => {
  router.visit(window.history.length > 1 ? window.history.back() : '/');
};
</script>
